import { render, staticRenderFns } from "./ApprovalList.vue?vue&type=template&id=7e323ac4&scoped=true"
import script from "./ApprovalList.vue?vue&type=script&lang=js"
export * from "./ApprovalList.vue?vue&type=script&lang=js"
import style0 from "./ApprovalList.vue?vue&type=style&index=0&id=7e323ac4&prod&lang=css"
import style1 from "./ApprovalList.vue?vue&type=style&index=1&id=7e323ac4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e323ac4",
  null
  
)

export default component.exports